// @ts-expect-error - @fontsource-variable/inter is not typed
import '@fontsource-variable/inter'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRouteWithContext,
} from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'

import { I18nProvider } from '@trevize/i18n'

import { DefaultErrorPage } from '#components/default-error-page.tsx'
import { DefaultNotFoundPage } from '#components/default-not-found-page.tsx'
import { api } from '#lib/trpc/react.tsx'

const releaseInfo = {
  VERSION: __VERSION__,
  HASH: __COMMIT_HASH__,
  DEPLOYED_AT: __DEPLOYED_AT__,
}

if (typeof window !== 'undefined') {
  window.__RELEASE_INFO = releaseInfo
}

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
  trpc: ReturnType<typeof api.useUtils>
}>()({
  component: RootDocument,
  errorComponent: DefaultErrorPage,
  notFoundComponent: DefaultNotFoundPage,
})

function RootDocument() {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `var __RELEASE_INFO = ${JSON.stringify(releaseInfo)};`,
        }}
      />
      <HeadContent />
      <Scripts />
      <I18nProvider locale="en" messages={{}}>
        <Outlet />
      </I18nProvider>
      {import.meta.env.DEV && (
        <TanStackDevtools
          plugins={[
            {
              name: 'TanStack Query',
              render: <ReactQueryDevtoolsPanel />,
              defaultOpen: true,
            },
            {
              name: 'TanStack Router',
              render: <TanStackRouterDevtoolsPanel />,
              defaultOpen: false,
            },
          ]}
        />
      )}
    </>
  )
}
